<div>
  <div class="modal-container">
    <div class="data-container" *ngIf="siteconfiguration">
      <div class="field-wrapper">
        <p class="text-start">Duplicar site</p>
      </div>
      <div class="data-container-body">
        <div class="field-wrapper">
          <div class="d-flex align-items-center">
            <span>https://3ddigitalvenue.com/</span
            ><input type="text" placeholder="fcbarcelona" [(ngModel)]="newMaster.client" />
            <button class="btn-secondary-action" (click)="checkIfExists()">Comprobar si la URL ya existe</button>
            <i class="fa fa-check ms-2" *ngIf="checkedSite && !sitealreadyExists"></i>
          </div>
        </div>
        <div class="selector-div-wrapper-sized">
          <div class="selector-div-wrapper align-items-center">
            <span>Publicar</span>
            <div class="selector-div">
              <select name="selector" class="selector" [(ngModel)]="newMaster.enabled">
                <option [ngValue]="true">Si</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="vertical-line"></div>
            </div>
          </div>
          <div class="selector-div-wrapper align-items-center">
            <span>Minisite de test</span>
            <div class="selector-div">
              <select name="selector" class="selector" [(ngModel)]="isSiteForTest">
                <option [ngValue]="true">Si</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="vertical-line"></div>
            </div>
          </div>
        </div>
        <div class="selector-div-wrapper-sized">
          <div class="selector-div-wrapper align-items-center">
            <span>Cliente</span>
            <ng-multiselect-dropdown
              [placeholder]="'select client'"
              [settings]="dropdownSettings"
              [data]="clientList"
              [(ngModel)]="clientSelected">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="selector-div-wrapper-sized">
          <div class="selector-div-wrapper align-items-center">
            <span>Recinto</span>
            <span class="fw-bold mx-3" style="min-width: 250px">{{ venueSelected?.name }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center mb-2 mt-2">
          <span>Version libreria: </span> <span class="ms-2 fw-bold">{{ libVersion }}</span>
        </div>
        <div class="table-container">
          <div>
            <span>Resumen</span>
            <table class="sb-table mb-3">
              <thead>
                <tr>
                  <th>Logo</th>
                  <th>Favicon</th>
                  <th>Main title</th>
                  <th>Subtitle</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <img [src]="logoPreview" *ngIf="!logoNewPreview" (click)="logoNewInput.click()" />
                    <img [src]="logoNewPreview" *ngIf="logoNewPreview" (click)="logoNewInput.click()" />

                    <input type="file" accept="image/*" class="d-none" #logoNewInput (change)="updateLogo($event)" />
                  </td>
                  <td>
                    <img [src]="faviconPreview" *ngIf="!faviconNewPreview" (click)="faviconNewInput.click()" />
                    <img [src]="faviconNewPreview" *ngIf="faviconNewPreview" (click)="faviconNewInput.click()" />
                    <input
                      type="file"
                      accept="image/*"
                      class="d-none"
                      #faviconNewInput
                      (change)="updateFavicon($event)" />
                  </td>
                  <td>
                    <input
                      type="text"
                      class="custom-large-input"
                      [(ngModel)]="siteconfiguration.toolsConfig.titles.title" />
                  </td>
                  <td>
                    <input
                      type="text"
                      class="custom-large-input"
                      [(ngModel)]="siteconfiguration.toolsConfig.titles.subtitle" />
                  </td>
                  <td class="text-center">
                    <span class="link-width">{{ siteconfiguration.toolsConfig.externalbtn.link }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <span>DVM</span>
            <table class="sb-table mb-3">
              <thead>
                <tr>
                  <th>Venue ID</th>
                  <th>Map ID</th>
                  <th>Minimap</th>
                  <th>Colores del mapa</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="entity-feature">
                      <div class="feature-value">
                        <div
                          class="d-flex align-items-center"
                          *ngIf="!editModes.venueId; else editmodeVenueId"
                          (click)="changeEditMode('venueId')">
                          <span>{{ newMaster.venue_id }}</span>
                          <button class="btn-action-edit">
                            <img id="edit" alt="Edit" />
                          </button>
                        </div>
                        <ng-template #editmodeVenueId>
                          <input type="text" placeholder="Venue id..." [(ngModel)]="newMaster.venue_id" />
                          <button class="btn-action-editing" (click)="updateVenue('venueId')">
                            <img id="check-sm-dark-gray" alt="Edit" />
                          </button>
                          <button class="btn-action-editing" (click)="cancelEditMode('venueId')">
                            <img id="close-dark-gray" alt="Edit" />
                          </button>
                        </ng-template>
                      </div>
                      <!-- <input type="text" class="custom-input" [(ngModel)]="newMaster.venue_id" /> -->
                    </div>
                  </td>
                  <td>
                    <input type="text" class="custom-input" [(ngModel)]="newMaster.map_id" />
                  </td>
                  <td>
                    <div *ngIf="siteconfiguration.toolsConfig.minimap && siteconfiguration.toolsConfig.minimap.enabled">
                      <input
                        type="text"
                        class="custom-input"
                        [(ngModel)]="siteconfiguration.toolsConfig.minimap.map_id" />
                    </div>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.colormap">
                    <span *ngIf="siteconfiguration.toolsConfig.colormap.default"> Por defecto </span>
                    <span *ngIf="!siteconfiguration.toolsConfig.colormap.default"> Personalizado </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <span>Funcionalidades Generales</span>
            <table class="sb-table mb-3">
              <thead>
                <tr>
                  <th *ngIf="siteconfiguration.toolsConfig.popups">Popups</th>
                  <th *ngIf="siteconfiguration.toolsConfig.searcher">Buscador</th>
                  <th *ngIf="siteconfiguration.toolsConfig.filters">Filtros</th>
                  <th *ngIf="siteconfiguration.toolsConfig.neighbours">Neighbours</th>
                  <th *ngIf="siteconfiguration.toolsConfig.translation">Traducciones</th>
                  <th *ngIf="siteconfiguration.toolsConfig.multivenue">Configuraciones</th>
                  <th *ngIf="siteconfiguration.toolsConfig.availability">Disponibilidad</th>
                  <th *ngIf="siteconfiguration.toolsConfig.comparator">Comparador</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngIf="siteconfiguration.toolsConfig.popups">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.popups.enabled
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.searcher">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.searcher.enabled
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.filters">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.filters?.enabled
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.neighbours">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.neighbours?.enabled
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.translation">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.translation?.enabled
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.multivenue">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.multivenue?.enabled
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.availability">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.availability?.unavailableNodesList
                      }"></i>
                  </td>
                  <td *ngIf="siteconfiguration.toolsConfig.comparator">
                    <i
                      [ngClass]="{
                        'fa fa-check': siteconfiguration.toolsConfig.comparator?.enabled
                      }"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              *ngIf="
                sitedatabase.workflow.id !== 3 && sitedatabase.workflow.id !== 4 && sitedatabase.workflow.id !== 7
              ">
              <span>Funcionalidades del Visor 360</span>
              <table class="sb-table mb-3">
                <thead>
                  <tr>
                    <th>Panos version</th>
                    <th>Copy Link</th>
                    <th>Fullscreen</th>
                    <th>VR</th>
                    <th>Indoor</th>
                    <th>Navigation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>{{ siteconfiguration.mapConfig.set_id }}</span>
                    </td>
                    <td>
                      <i
                        [ngClass]="{
                          'fa fa-check': siteconfiguration.toolsConfig.copylink.enabled
                        }"></i>
                    </td>
                    <td>
                      <i
                        [ngClass]="{
                          'fa fa-check': siteconfiguration.toolsConfig.fullscreen?.enabled
                        }"></i>
                    </td>
                    <td>
                      <i
                        [ngClass]="{
                          'fa fa-check': siteconfiguration.toolsConfig.vr?.enabled
                        }"></i>
                    </td>
                    <td>
                      <i
                        [ngClass]="{
                          'fa fa-check': siteconfiguration.toolsConfig.indoor?.enabled
                        }"></i>
                    </td>
                    <td>
                      <i
                        [ngClass]="{
                          'fa fa-check': siteconfiguration.toolsConfig.navigation?.enabled
                        }"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="siteconfiguration.toolsConfig.colormap && !siteconfiguration.toolsConfig.colormap.default">
              <span>Colores del mapa</span>
              <table class="sb-table mb-3">
                <thead>
                  <tr>
                    <th colspan="2"><span>Sector</span></th>
                    <th colspan="2"><span>Asiento</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Available</span>
                    </td>
                    <td>
                      <span>Selected</span>
                    </td>
                    <td>
                      <span>Available</span>
                    </td>
                    <td>
                      <span>Selected</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="color-bullets-list">
                        <span
                          title="normal"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.section?.available.normal.none.fillStyle
                          }"></span>
                        <span
                          title="hover"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.section?.available?.hover?.none.fillStyle
                          }"></span>
                      </div>
                    </td>
                    <td>
                      <div class="color-bullets-list">
                        <span
                          title="normal"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.section?.selected?.normal.none.fillStyle
                          }"></span>
                        <span
                          title="hover"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.section?.selected?.hover.none.fillStyle
                          }"></span>
                      </div>
                    </td>
                    <td>
                      <div class="color-bullets-list">
                        <span
                          title="normal"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.seat?.available.normal.none.fillStyle
                          }"></span>
                        <span
                          title="hover"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.seat?.available.hover.none.fillStyle
                          }"></span>
                      </div>
                    </td>
                    <td>
                      <div class="color-bullets-list">
                        <span
                          title="normal"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.seat?.selected.normal.none.fillStyle
                          }"></span>
                        <span
                          title="hover"
                          class="color-bullet"
                          [ngStyle]="{
                            'background-color':
                              siteconfiguration.toolsConfig.colormap.manual?.seat?.selected.hover.none.fillStyle
                          }"></span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="sitealreadyExists" class="confirmdelete">
          <div class="alert alert-danger" role="alert">
            <div>
              <b>
                <a target="_blank" [href]="sitealreadyExists.site.url" class="danger-link">
                  <i class="fa fa-exclamation-triangle"></i>
                  <i class="fa fa-external-link ms-2 me-2"></i>
                  Ya existe un minisite con esa URL.
                </a>
              </b>
            </div>
            <div>
              ID: <b>{{ sitealreadyExists.site.id }}</b>
            </div>
            <div>
              Venue ID: <b>{{ sitealreadyExists.site.venue_code }}</b>
            </div>
            <div>
              Map ID: <b>{{ sitealreadyExists.site.map_id }}</b>
            </div>
            <div>
              Workflow: <b>{{ sitealreadyExists.site.workflow.name }}</b>
            </div>

            <button
              *ngIf="!checkdeleteconfirm; else confirmdelete"
              id="firsttrydelete"
              class="btn-secondary-action"
              (click)="checkdeleteconfirm = true">
              Eliminar este minisite
            </button>

            <ng-template #confirmdelete>
              <div *ngIf="checkdeleteconfirm">
                <hr />
                <div class="mb-2 text-center">
                  <span>Esta acción no se podrá deshacer.</span><br />
                  <span>¿ Eliminar antiguo minisite ?</span>
                </div>
                <div class="d-flex justify-content-center" *ngIf="!deletingSite">
                  <button class="btn-secondary-action me-4" (click)="checkdeleteconfirm = false">No</button>
                  <button class="btn-secondary-action" (click)="deletesite(sitealreadyExists.site.id)">Si</button>
                </div>
                <div class="d-flex align-items-center justify-content-center" *ngIf="deletingSite">
                  <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                  <span class="sr-only">Deleting...</span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="btns-containers">
          <button class="cancel-btn" (click)="onDismiss('cancel')">Cancelar</button>
          <button
            class="confirm-btn"
            (click)="onConfirm()"
            [disabled]="
              !newMaster.client ||
              siteconfiguration.mapConfig.client === newMaster.client ||
              sitealreadyExists ||
              !clientSelected.length ||
              venueSelected.key === null
            ">
            Confirmar
          </button>
        </div>
      </div>
      <div [hidden]="!loading" class="loading-wrapper">
        <div class="custom-loader"></div>
      </div>
    </div>

    <button type="button" class="" (click)="onDismiss('cancel')" data-dismiss="modal">
      <span class="ti ti-close"></span>
    </button>
  </div>
</div>
